import { FetchCommentsQuery, PostCommentForm } from "./comments-queries.interface";

export const mapFetchParams = (params: FetchCommentsQuery) => ({
  app_name: "core",
  model_id: params.resourceId,
  model_name: params.resourceType,
});

export const mapPostParams = (params: PostCommentForm) => ({
  app_name: "core",
  content: params.comment,
  model_id: params.resourceId,
  model_name: params.resourceType,
});
